const config = {
  blockCheck: true,
  mbAudioItemData: [
    {
      maskConfig: {
        click: { src: 'games/page014_game0/audio/click.mp3' },
        src: 'games/page014_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-273px',
          'margin-top': '-100px',
        },
      },
      id: 'a01',
      src: 'games/page014_game0/audio/21_scared.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page014_game0/img/audioOn.png', iconOff: 'games/page014_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: 250,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page014_game0/audio/click.mp3' },
        src: 'games/page014_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-273px',
          'margin-top': '-100px',
        },
      },
      id: 'a02',
      src: 'games/page014_game0/audio/20_hungry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page014_game0/img/audioOn.png', iconOff: 'games/page014_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: 250,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page014_game0/audio/click.mp3' },
        src: 'games/page014_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-273px',
          'margin-top': '-100px',
        },
      },
      id: 'a03',
      src: 'games/page014_game0/audio/15_happy.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page014_game0/img/audioOn.png', iconOff: 'games/page014_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: 250,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page014_game0/audio/click.mp3' },
        src: 'games/page014_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-273px',
          'margin-top': '-100px',
        },
      },
      id: 'a04',
      src: 'games/page014_game0/audio/17_calm.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page014_game0/img/audioOn.png', iconOff: 'games/page014_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: 250,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page014_game0/audio/click.mp3' },
        src: 'games/page014_game0/img/folia.png',
        cssStyle: {
          'margin-left': '-273px',
          'margin-top': '-100px',
        },
      },
      id: 'a05',
      src: 'games/page014_game0/audio/18_angry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page014_game0/img/audioOn.png', iconOff: 'games/page014_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 100,
        x: 250,
      },
      width: '48px',
      height: '48px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page014_game0/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,
  dontAcceptIncorrectLines: true,
  linesAboveItems: true,

  linesStyle: {
    colors: {
      bad: 'red',
      good: 'green',
      neutral: '#4cb9fa',
    },
    size: 5,
  },
  rules: [
    { connectId: 1, connectedWith: 6 },
    { connectId: 2, connectedWith: 7 },
    { connectId: 3, connectedWith: 8 },
    { connectId: 4, connectedWith: 9 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [
    { src: 'games/page014_game0/audio/false.mp3', id: 'endConnect' },
    { src: 'games/page014_game0/audio/click.mp3', id: 'startConnect' },
    { src: 'games/page014_game0/audio/21_scared.mp3', id: 'scared' },
    { src: 'games/page014_game0/audio/20_hungry.mp3', id: 'hungry' },
    { src: 'games/page014_game0/audio/15_happy.mp3', id: 'happy' },
    { src: 'games/page014_game0/audio/17_calm.mp3', id: 'calm' },
  ],
  groups: [
    {
      name: 'left',
      items: [
        {
          audio: 'a01',
          connectId: 1,
          image: { src: 'games/page014_game0/img/ludek_scared.png' },
          imageStyle: { position: 'absolute', width: '250px', height: '250px' },
          pos: {
            x: 82,
            y: 709,
            width: 250,
            height: 250,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
        },
        {
          audio: 'a02',
          connectId: 2,
          image: { src: 'games/page014_game0/img/ludek_hungry.png' },
          imageStyle: { position: 'absolute', width: '250px', height: '250px' },
          pos: {
            x: 440,
            y: 709,
            width: 250,
            height: 250,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
        },
        {
          audio: 'a03',
          connectId: 3,
          image: { src: 'games/page014_game0/img/ludek_happy.png' },
          imageStyle: { position: 'absolute', width: '251px', height: '250px' },
          pos: {
            x: 799,
            y: 709,
            width: 251,
            height: 250,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
        },
        {
          audio: 'a04',
          connectId: 4,
          image: { src: 'games/page014_game0/img/ludek_calm.png' },
          imageStyle: { position: 'absolute', width: '251px', height: '250px' },
          pos: {
            x: 1158,
            y: 709,
            width: 251,
            height: 250,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
        },
        {
          audio: 'a05',
          connectId: 5,
          image: { src: 'games/page014_game0/img/ludek_angry.png' },
          imageStyle: { position: 'absolute', width: '251px', height: '250px' },
          pos: {
            x: 1516,
            y: 709,
            width: 251,
            height: 250,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          connectId: 6,
          audioId: 'scared',
          image: { src: 'games/page014_game0/img/scared.png' },
          imageStyle: { position: 'absolute', width: '421px', height: '457px' },
          pos: {
            x: 54,
            y: 111,
            width: 421,
            height: 457,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 205, y: 401 }],
        },
        {
          connectId: 7,
          audioId: 'hungry',
          image: { src: 'games/page014_game0/img/hungry.png' },
          imageStyle: { position: 'absolute', width: '408px', height: '441px' },
          pos: {
            x: 510,
            y: 119,
            width: 408,
            height: 441,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 199, y: 393 }],
        },
        {
          connectId: 8,
          audioId: 'happy',
          image: { src: 'games/page014_game0/img/happy.png' },
          imageStyle: { position: 'absolute', width: '412px', height: '450px' },
          pos: {
            x: 953,
            y: 115,
            width: 412,
            height: 450,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 200, y: 397 }],
        },
        {
          connectId: 9,
          audioId: 'calm',
          image: { src: 'games/page014_game0/img/calm.png' },
          imageStyle: { position: 'absolute', width: '415px', height: '443px' },
          pos: {
            x: 1400,
            y: 118,
            width: 415,
            height: 443,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          hooks: [{ x: 202, y: 394 }],
        },
      ],
    },
  ],
};
export default config;
